import React from 'react';
import { Box } from '@chakra-ui/react';

import { BankFormPropTypes } from './bank.prop-types';

import type { BankFormProps } from './bank.types';

const layoutProps: Record<string, any> = {
  gap: 6,
  columnGap: 4,
};

const BankForm = React.forwardRef(({ memo }: BankFormProps, forwardRef: any) => (
  <div ref={forwardRef}>
    <Box>
      You will be provided transfer instructions after confirming the reservation.
    </Box>
    {!!memo && <Box mt={layoutProps.gap || 6} dangerouslySetInnerHTML={{ __html: memo }} />}
  </div>
));

BankForm.propTypes = BankFormPropTypes;

export { BankForm };
